import {State} from "../rootReducer";
import {createSelector} from "reselect";
import {Category, IAttributes, IProject} from "./index";
import {flatten} from "lodash/fp";

export const getAttributes = (state: State) => state.project.attributes;
export const getActiveCategory = (state: State) => state.project.active;
export const getSelectedAttributes = (state: State) =>
  state.project.selectedAttributes;
export const getZoom = (state: State) => state.project.zoom;
export const getCentred = (state: State) => state.project.centred;
export const getCustomAttributes = (state: State) => state.project.custom;
export const getFliped = (state: State) => state.project.fliped;
export const getWall = (state: State) => state.project.wall;
export const getHistory = (state: State) => state.project.history;
export const getCart = (state: State) => state.project.cart;
export const getInstallation = (state: State) => state.project.installation;
export const getMeasurement = (state: State) => state.project.measurement;
export const getId = (state: State) => state.project.id;
export const getExpanded = (state: State) => state.project.expanded
export const getLoading = (state: State) => state.project.loading
export const getDate = (state: State) => state.project.date;
export const getEditable = (state: State) => state.project.editable;
export const getCartId = (state: State) => state.project.cartId;
export const getLoaded = (state: State) => state.project.loaded;
export const getDistributors = (state: State) => state.project.distributors;
export const getForm = (state: State) => state.project.form;
export const getSelectedDistributors = (state: State) =>
  state.project.selectedDist;
export const getSearchDist = (state: State) => state.project.searchDist;


export const getDistributorsSearched = createSelector(
  [getDistributors, getSearchDist, getSelectedDistributors],
  (dist, search, selected) =>
    dist
      .filter((d) =>
        !search
          ? true
          : d.name.toLowerCase().includes(search.toLowerCase()) ||
            d.address.toLowerCase().includes(search.toLowerCase())
      )
      .filter((d) => !selected.find((s) => s.id === d.id))
);

export const getSelectedAttributesMapped = createSelector(
  [getAttributes, getSelectedAttributes],
  (attr, selected) => selected.filter(Boolean).map((s) => {

    const a = attr.find((a) => a.id === s)

        if(a?.category == 'jambColor'){

              const sel = selected.map((s) => attr.find(a => a.id === s))

              const jambSize = sel.filter(Boolean).find(att => att.category === Category.JambSize)?.name
              const colorTag = a?.name

              const special = sel.filter(Boolean).find(s => 'special' in s.dependency)

                if(!jambSize || !colorTag || !special){
                    return a
                }

              const specialAttr = special?.dependency?.special?.find(s => s.jambSize === jambSize && colorTag?.toLowerCase().includes(s?.jambColor?.toLowerCase()))

              return {...a, price: specialAttr?.price}
        } else {
          return a
        }

  })
);

export const isModelSelected = createSelector(
  [getSelectedAttributesMapped],
  (selected) => {
      return !!selected.find((s) => s?.category === Category.Model)
  }
);

export const getCurrentProject = createSelector(
  [
    getId,
    getDate,
    getFliped,
    getEditable,
    getWall,
    getSelectedAttributesMapped,
  ],
  (id, date, fliped, editable, wall, attr): IProject => {
    return {
      id: id || "",
      date: date || new Date().getTime(),
      fliped,
      wall,
      count: 1,
      components: attr as IAttributes[],
      editable: editable,
    };
  }
);

export const getAttributesFiltered:any = createSelector(
    [getAttributes, getSelectedAttributesMapped],
    (attr: IAttributes[], selected: IAttributes[]) => {
        return attr.map((a) => {
            if(flatten(Object.values(a.dependency)).length === 0){
                return a
            } else {
                if(Object.entries(a.dependency).every(([key, arr]:any) => {
                    if(key === 'special'){
                        return true
                    }
                    const selectedCategory = selected.filter(Boolean).filter(s => s.category === key)

                    const depArr = arr.filter(a => 'slug' in a)
                    const notArr = arr.filter(a => !('slug' in a))

                    const isDepMeet = depArr.length === 0 || depArr.some(a => selectedCategory.find(sel => sel.slug === a.slug))
                    const isNotMeet = notArr.length === 0 || notArr.every(a => !selectedCategory.find(sel => sel.slug === a.not))

                    return  isDepMeet && isNotMeet
                })){
                  if(a.category === Category.Color){
                    if(selected.some(s => (s.category === Category.Glass && s.name.includes('VSG CZARNE')))){
                        return {...a, disabled: !a.name.includes('CZARNE VSG')}
                      } else {
                        return {...a, disabled: a.name.includes('CZARNE VSG')}
                    }
                    }
                  return {...a}
                } else {
                    return  { ...a, disabled: true }
                }
            }
        }
        );
    }
);

export const getAttributesByCategory = (category?: Category[]) =>
  createSelector([getAttributesFiltered], (attr) =>
      (attr as any).filter((a) => !!category?.find((c) => c === a?.category) && !a.disabled)
  );


export const getGlassCount = createSelector([getSelectedAttributesMapped], (attr) => {
  const glassCount = attr.find(a => a && a['glassCount'])

  if(glassCount) {
    return glassCount?.glassCount
  }

  return 0

})